import * as t from "io-ts";
import { ExportedTreeV, PropertiesDataV } from "@/types/tree";
import { CSSSelectorListV } from "@/types/selectors";
import { ElementPresetsV } from "@/types/presets";

export const RevisionCommonDataV = t.type({
  id: t.union([t.number, t.string]),
  date: t.string,
  author: t.union([t.string, t.literal(false)])
});
export type RevisionCommonData = t.TypeOf<typeof RevisionCommonDataV>;

// IO-TS generic types didn't work correctly with TypeScript 3.8.3,
// stating that "object type isn't assignable to any type".
// Thus, we're using different types for document, global settings and selector revisions instead.

export const GlobalSettingsRevisionV = t.intersection([
  RevisionCommonDataV,
  t.type({
    globalSettings: PropertiesDataV
  })
]);
export type GlobalSettingsRevision = t.TypeOf<typeof GlobalSettingsRevisionV>;

export const GlobalSettingsRevisionsListV = t.array(GlobalSettingsRevisionV);
export type GlobalSettingsRevisionsList = t.TypeOf<
  typeof GlobalSettingsRevisionsListV
>;

// Selectors

export const SelectorsRevisionV = t.intersection([
  RevisionCommonDataV,
  t.type({
    selectors: CSSSelectorListV
  })
]);
export type SelectorsRevision = t.TypeOf<typeof SelectorsRevisionV>;

export const SelectorsRevisionsListV = t.array(SelectorsRevisionV);
export type SelectorsRevisionsList = t.TypeOf<typeof SelectorsRevisionsListV>;

// Presets

export const PresetsRevisionV = t.intersection([
  RevisionCommonDataV,
  t.type({
    presets: ElementPresetsV
  })
]);
export type PresetsRevision = t.TypeOf<typeof PresetsRevisionV>;

export const PresetsRevisionsListV = t.array(PresetsRevisionV);
export type PresetsRevisionsList = t.TypeOf<typeof PresetsRevisionsListV>;

// Document

export const DocumentRevisionWithJsonTreeV = t.intersection([
  RevisionCommonDataV,
  t.type({
    tree: t.string
  })
]);

export const DocumentRevisionV = t.intersection([
  RevisionCommonDataV,
  t.type({
    tree: ExportedTreeV
  })
]);
export type DocumentRevision = t.TypeOf<typeof DocumentRevisionV>;

export const DocumentRevisionsV = t.type({
  revisions: t.array(DocumentRevisionV)
});

export const DocumentRevisionsDataFromServerV = t.union([
  t.type({ revisions: t.array(DocumentRevisionWithJsonTreeV) }),
  t.type({ unsupported: t.string })
]);

export type DocumentRevisionsData = {
  revisions: DocumentRevision[];
  currentUnsavedRevision: DocumentRevision | null;
};

export type RevisionUiItem<T extends RevisionCommonData = RevisionCommonData> =
  {
    revisionData: T;
    isSelected: boolean;
  };
